module.exports = {
	init: function(){
		this.navbar();
	},
	navbar: function(){
		//navbar trigger
		$(document).on('click', '.navbar_trigger', function(event) {
			event.preventDefault();
			$(this).toggleClass('is_open');
			$('body, html').toggleClass('is_navopen');
		});
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/resources/js/modules/nav.js
// module id = 3
// module chunks = 0